import Const from 'constants';

const AvoidFewPassReceivers = {
    setAvoidFewPassReceiversFromStorage(value) {
        return (dispatch) => {
            dispatch(this.avoidFewPassReceivers(value, {saveToStorage: false}));
        };
    },

    avoidFewPassReceivers(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_AVOID_FEW_PASS_RECEIVERS,
                avoidFewPassReceivers: Boolean(value),
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('avoidFewPassReceivers', function (state) {
                    const {filters} = state.lineupsData;

                    return filters.avoidFewPassReceivers;
                }),
            );
        };
    },
};

export default AvoidFewPassReceivers;
